import { gql } from '@apollo/client';

export const REPORT_FRAGMENT = gql`
  fragment ReportFragment on Report {
    id
    lang
    status
    report
    signature
    icd
    created_at
    date_report
    appointment_id
  }
`;

export const REPORT_FILE_FRAGMENT = gql`
  fragment ReportFileFragment on ReportsFile {
    id
    file
    note
    created_at
    updated_at
    appointment_id
  }
`;
